import {Condition, RulesStrategy, ValidationStrategy} from "./index";

/**
 * Класс проверяет чтоб все условия были верны.
 * Есть controlTargetId - поле в котором нужно взять значение
 * value - свойство которое нужно сравнить со значением выше
 * option - метод сравнения Равно/Не равно
 */
class AndConditionStrategy implements ValidationStrategy {
    validate(condition: Condition[], controls) {
        let arrayResults: boolean[] = [];
        condition.map((item) => {
            switch (item.option) {
                case 'Equal': {
                    let controlTargetValue = RulesStrategy.getValue(item.controlTargetId, controls);
                    controlTargetValue === item.value && arrayResults.push(true);
                    break;
                }
                case 'NotEqual': {
                    let controlTargetValue = RulesStrategy.getValue(item.controlTargetId, controls);
                    controlTargetValue !== item.value && arrayResults.push(true);
                    break;
                }
                default: {
                    throw new Error('Not defined validation method');
                }
            }
        });

        //Если длина arrayResults и condition совпадают, значит все значения true, а потому отдаем true
        return arrayResults.length === condition.length;
    }
}
export default AndConditionStrategy;